import { BuilderStore } from '@builder.io/react';
import { Product } from 'lib/bigcommerce/types';
import { useEffect, useState } from 'react';
import { ProofDetails } from '../../app/api/proof/types';
import { BackToTop } from './back-to-top';
import { Chat } from './snap-chat';
import { SocialProof, SocialProofContext } from './social-proof';
import './sticky-utility-with-social-proof.scss';

export function StickyUtilityWithSocialProof({
  builderState,
  productSku,
  attributes
}: {
  builderState: BuilderStore;
  productSku: string;
  attributes: { style: any; className: string; 'builder-id': string; id: string };
}) {
  const [productId, setProductId] = useState<string | null>(null);
  const [proofs, setProofs] = useState<ProofDetails[]>([]);
  const [hasSocialProofs, setHasSocialProofs] = useState<boolean | null>(null);

  useEffect(() => {
    const resolveProductId = async () => {
      try {
        let resolvedProductId: string | null = null;
        if (productSku) {
          const response = await fetch(`/api/product?sku=${productSku}`);
          const product: Product | undefined = await response.json();
          resolvedProductId = product?.id ?? null;
        } else {
          resolvedProductId = builderState.state.product?.id ?? null;
        }
        setProductId(resolvedProductId);
      } catch (e) {
        setProductId(builderState.state.product?.id ?? null);
      }
    };
    resolveProductId();
  }, [builderState.state.product?.id, productSku]);

  useEffect(() => {
    if (!productId) return;

    const fetchSocialProofs = async (): Promise<void> => {
      try {
        const proofResponse = await fetch(
          `${process.env.NEXT_PUBLIC_DOMAIN_NAME}/api/proof/${productId}`
        );
        const proofs = await proofResponse.json();
        setProofs(proofs);
        setHasSocialProofs(!!proofs.length);
      } catch (error) {
        console.error('Failed to fetch social proofs:', error);
        setProofs([]);
        setHasSocialProofs(false);
      }
    };

    fetchSocialProofs();
  }, [productId]);

  if (hasSocialProofs === null) {
    return null;
  }

  return (
    <div
      id="sticky-utility-with-proof"
      className={`sticky-utility-with-proof${hasSocialProofs ? '' : '__with-placeholder'}`}
    >
      {hasSocialProofs ? (
        <SocialProof
          socialProofs={proofs}
          builderState={builderState}
          context={SocialProofContext.StickyBarContext}
        />
      ) : (
        <div className="social-proof-placeholder" />
      )}
      <div className="utility-buttons">
        <Chat buttonPosition="right" attributes={attributes} />
        <BackToTop buttonPosition="right" attributes={attributes} />
      </div>
    </div>
  );
}
